
import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { Download, ArrowLeft, File, FileText, Database, Layers, FolderOpen, Grid3x3, Image as ImageIcon, X, Eye } from 'lucide-react';

const ArchivosDescargables = () => {
  const navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState('todos');
  const [previewImage, setPreviewImage] = useState<string | null>(null);

  const archivos = [
  {
    id: 1,
    nombre: "Microcuencas Hidrográficas - Shapefile",
    descripcion: "Polígonos vectoriales de las 79 microcuencas jerarquizadas de Chiapas",
    categoria: "Hidrología",
    formato: "SHP (Shapefile)",
    tamano: "5 MB",
    fechaActualizacion: "2024-12-14",
    url: "https://drive.google.com/uc?export=download&id=11p2IaGue6_99CSW3PUl9MN0hjGSkJMw8"
  },
  {
    id: 2,
    nombre: "Precipitación Anual",
    descripcion: "Raster de precipitación promedio anual (mm) basado en datos históricos 2000-2024 para el estado de Chiapas",
    categoria: "Clima",
    formato: "GeoTIFF",
    tamano: "4 MB",
    fechaActualizacion: "2026-02-12",
    url: "https://zenodo.org/records/18613174"
  },
  {
    id: 3,
    nombre: "Áreas Naturales Protegidas Estatal",
    descripcion: "Áreas Naturales Protegidas del estado de Chiapas",
    categoria: "Agropecuario",
    formato: "SHP (Shapefile)",
    tamano: "1 MB",
    fechaActualizacion: "2024-12-11",
    url: "https://drive.google.com/uc?export=download&id=1dx8Grm3hLfSvDZSqAZW6Z0ZBQF_7YSjq"
  },
  {
    id: 4,
    nombre: "Áreas Naturales Protegidas Federal",
    descripcion: "Polígonos de ANPs federales y estatales en Chiapas",
    categoria: "Ambiental",
    formato: "SHP (Shapefile)",
    tamano: "1 MB",
    fechaActualizacion: "2024-12-04",
    url: "https://drive.google.com/uc?export=download&id=1bWmjwebZT3wgHqRqpKmnTK0XOb7PcY3U"
  },
    {
    id: 5,
    nombre: "Zona Parcelaria del RAN",
    descripcion: "Polígonos de zonas parcelarias del RAN",
    categoria: "Ambiental",
    formato: "SHP (Shapefile)",
    tamano: "13 MB",
    fechaActualizacion: "2025-02-01",
    url: "https://drive.google.com/uc?export=download&id=1FfEmZEv3d7zM1cUbNbje4CwMO6Q0d9dW"
  },
    {
    id: 6,
    nombre: "Tierras de uso Común del RAN",
    descripcion: "Polígonos de Tierras de uso Común",
    categoria: "Ambiental",
    formato: "SHP (Shapefile)",
    tamano: "4 MB",
    fechaActualizacion: "2025-02-01",
    url: "https://drive.google.com/uc?export=download&id=1jkTRzbdrFCn59g95KERx2XFOtRjczWrK"
  },
,
    {
    id:7,
    nombre: "Nucleos agrarios del RAN",
    descripcion: "Polígonos de Nucleos agrarios del RAN",
    categoria: "Ambiental",
    formato: "SHP (Shapefile)",
    tamano: "4 MB",
    fechaActualizacion: "2025-02-01",
    url: "https://drive.google.com/uc?export=download&id=1XuMSXNN-ECvsBFuio9gCFU9ydDISBmMC"
  },
,
    {
    id: 8,
    nombre: "Asentamientos Humanos del RAN",
    descripcion: "Polígonos de Asentamientos Humanos del RAN",
    categoria: "Ambiental",
    formato: "SHP (Shapefile)",
    tamano: "4 MB",
    fechaActualizacion: "2025-02-01",
    url: "https://drive.google.com/uc?export=download&id=1BU7D1vyQXBYA-7BLWOHkkaxMumw8zVcd"
  },  
  ];


  const categorias = [
  { id: 'todos', nombre: 'Todos', icono: Grid3x3 },
  { id: 'Hidrología', nombre: 'Hidrología', icono: Database },
  { id: 'Clima', nombre: 'Clima', icono: FileText },
  { id: 'Ambiental', nombre: 'Ambiental', icono: FolderOpen },
  { id: 'Agropecuario', nombre: 'Agropecuario', icono: File }];



  const archivosFiltrados = selectedCategory === 'todos' ?
  archivos :
  archivos.filter((archivo) => archivo.categoria === selectedCategory);

  const handleDownload = (url: string, nombre?: string) => {
    if (url.includes(window.location.origin)) {
      const link = document.createElement('a');
      link.href = url;
      link.download = nombre || '';
      link.click();
    } else {
      window.open(url, "_blank", "noopener,noreferrer");
    }
  };


  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <motion.header
        initial={{ y: -50, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8 }}
        className="bg-gradient-to-r from-blue-600 to-green-600 shadow-lg">
        
        <div className="container mx-auto px-6 py-6">
          <div className="flex items-center justify-between">
            <button
              onClick={() => navigate('/')}
              className="flex items-center space-x-2 text-white hover:text-blue-100 transition-colors duration-200">
              <ArrowLeft className="w-6 h-6" />
              <span>Volver al Inicio</span>
            </button>
            <div className="text-center">
              <h1 className="text-3xl md:text-4xl font-bold text-white">Archivos Descargables</h1>
              <p className="text-blue-50">Datos Raster y Vectoriales</p>
            </div>
            <div className="w-32"></div>
          </div>
        </div>
      </motion.header>

      <div className="container mx-auto px-6 py-12">
        {/* Descripción */}
        <motion.div
          initial={{ y: 30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="bg-gradient-to-r from-blue-50 to-green-50 rounded-xl p-8 border border-blue-200 shadow-md mb-12">
          
          <h2 className="text-2xl font-bold text-gray-800 mb-4">Repositorio de Datos Geoespaciales</h2>
          <p className="text-gray-700 mb-4">Descarga archivos raster (GeoTIFF) y vectoriales (Shapefile) utilizados en el análisis de jerarquización 
            de microcuencas.

          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
            <div className="text-center">
              <div className="text-blue-600 font-semibold">Formato Principal</div>
              <div className="text-gray-600">GeoTIFF / Shapefile</div>
            </div>
            <div className="text-center">
              <div className="text-green-600 font-semibold">Sistema de Coordenadas</div>
              <div className="text-gray-600">WGS84 / UTM 15N</div>
            </div>
            <div className="text-center">
              <div className="text-purple-600 font-semibold">Total de Archivos</div>
              <div className="text-gray-600">{archivos.length} conjuntos de datos</div>
            </div>
          </div>
        </motion.div>

        {/* Filtros por categoría */}
        <motion.div
          initial={{ y: 30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="mb-12">
          
          <div className="flex flex-wrap justify-center gap-4">
            {categorias.map((categoria) =>
            <button
              key={categoria.id}
              onClick={() => setSelectedCategory(categoria.id)}
              className={`flex items-center space-x-2 px-6 py-3 rounded-xl font-semibold transition-all duration-300 ${
              selectedCategory === categoria.id ?
              'bg-gradient-to-r from-blue-600 to-green-600 text-white shadow-lg' :
              'bg-white text-gray-700 hover:bg-gray-100 border border-gray-300 shadow-sm'}`
              }>
                <categoria.icono className="w-5 h-5" />
                <span>{categoria.nombre}</span>
              </button>
            )}
          </div>
        </motion.div>

        {/* Lista de archivos */}
        <motion.div
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.5 }}
          className="space-y-6">
          
          {archivosFiltrados.map((archivo, index) =>
          <motion.div
            key={archivo.id}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            className="bg-white border border-gray-200 rounded-xl p-6 shadow-md hover:shadow-lg transition-shadow duration-300">

              <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
                <div className="flex-1">
                  <div className="flex items-center gap-3 mb-2">
                    <File className="w-6 h-6 text-blue-600" />
                    <h3 className="text-xl font-bold text-gray-800">{archivo.nombre}</h3>
                  </div>
                  <p className="text-gray-600 mb-3">{archivo.descripcion}</p>
                  <div className="flex flex-wrap gap-4 text-sm">
                    <span className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full">
                      {archivo.categoria}
                    </span>
                    <span className="px-3 py-1 bg-gray-100 text-gray-700 rounded-full">
                      {archivo.formato}
                    </span>
                    <span className="px-3 py-1 bg-green-100 text-green-800 rounded-full">
                      {archivo.tamano}
                    </span>
                    <span className="px-3 py-1 bg-purple-100 text-purple-800 rounded-full">
                      Actualizado: {new Date(archivo.fechaActualizacion).toLocaleDateString('es-ES')}
                    </span>
                  </div>
                </div>
                <button
                onClick={() => handleDownload(archivo.url, archivo.nombre)}
                className="flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-blue-600 to-green-600 text-white rounded-xl hover:from-blue-700 hover:to-green-700 transition-all duration-300 shadow-md hover:shadow-lg whitespace-nowrap">

                  <Download className="w-5 h-5" />
                  Descargar
                </button>
              </div>
            </motion.div>
          )}
        </motion.div>

        {/* Sección de Imágenes Descargables */}
        <motion.div
          initial={{ y: 30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          className="mt-12">
          <h2 className="text-2xl font-bold text-gray-800 mb-6">Imágenes Descargables</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Imagen 1 */}
            <motion.div
              whileHover={{ scale: 1.02 }}
              className="bg-white border border-gray-200 rounded-xl p-6 shadow-md hover:shadow-lg transition-all duration-300">
              <div className="aspect-video bg-gray-100 rounded-lg mb-4 overflow-hidden cursor-pointer"
              onClick={() => setPreviewImage('https://lh3.googleusercontent.com/d/1CWLeh8iQRAd1gOGi95LEHFP3SYj-MzRS')}>
                <img
                  src="https://lh3.googleusercontent.com/d/1CWLeh8iQRAd1gOGi95LEHFP3SYj-MzRS"
                  alt="Ejes Estrategicos"
                  className="w-full h-full object-cover hover:scale-110 transition-transform duration-300" />

              </div>
              <h3 className="text-lg font-bold text-gray-800 mb-2">Ejes estratégicos para la gestión de microcuencas</h3>
              <p className="text-gray-600 text-sm mb-4">Estrategia integral de política pública para el manejo, la restauración y la sostenibilidad de las microcuencas</p>
              <div className="flex gap-3">
                <button
                  onClick={() => setPreviewImage('https://lh3.googleusercontent.com/d/1CWLeh8iQRAd1gOGi95LEHFP3SYj-MzRS')}
                  className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg transition-colors duration-300">
                  <Eye className="w-4 h-4" />
                  Previsualizar
                </button>
                <button
                  onClick={() => handleDownload('https://drive.google.com/uc?export=download&id=1OqQCke7bGMUy8nKClquk2gotkl131x0G', 'EjesEstrategicos.jpg')}
                  className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-gradient-to-r from-blue-600 to-green-600 hover:from-blue-700 hover:to-green-700 text-white rounded-lg transition-all duration-300 shadow-md">
                  <Download className="w-4 h-4" />
                  Descargar
                </button>
              </div>
            </motion.div>

            {/* Imagen 2 */}
            <motion.div
              whileHover={{ scale: 1.02 }}
              className="bg-white border border-gray-200 rounded-xl p-6 shadow-md hover:shadow-lg transition-all duration-300">
              <div className="aspect-video bg-gray-100 rounded-lg mb-4 overflow-hidden cursor-pointer"
              onClick={() => setPreviewImage('https://lh3.googleusercontent.com/d/1UY7Zt8DB-W47x82m9da80-USSE816GAh')}>
                <img
                  src="https://lh3.googleusercontent.com/d/1UY7Zt8DB-W47x82m9da80-USSE816GAh"
                  alt="Imagen 2"
                  className="w-full h-full object-cover hover:scale-110 transition-transform duration-300"></img>

              </div>
              <h3 className="text-lg font-bold text-gray-800 mb-2">Metodología INIFAP: Planeación de Microcuencas</h3>
              <p className="text-gray-600 text-sm mb-4">Descripción general de la metodología de planeación de microcuencas</p>
              <div className="flex gap-3">
                <button
                  onClick={() => setPreviewImage('https://lh3.googleusercontent.com/d/1UY7Zt8DB-W47x82m9da80-USSE816GAh')}
                  className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-lg transition-colors duration-300">
                  <Eye className="w-4 h-4" />
                  Previsualizar
                </button>
                <button
                  onClick={() => handleDownload('https://drive.google.com/uc?export=download&id=1VOS4pVAqdpkeqO-Pt-Cp2puxNa69_A_a', 'Planeación de Microcuencas.jpg')}
                  className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-gradient-to-r from-blue-600 to-green-600 hover:from-blue-700 hover:to-green-700 text-white rounded-lg transition-all duration-300 shadow-md">
                  <Download className="w-4 h-4" />
                  Descargar
                </button>
              </div>
            </motion.div>
          </div>
        </motion.div>

        {/* Nota al pie */}
        











      </div>

      {/* Modal de Previsualización */}
      {previewImage &&
      <div
        className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4"
        onClick={() => setPreviewImage(null)}>
          <motion.div
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          className="relative max-w-6xl w-full max-h-[90vh] bg-white rounded-2xl shadow-2xl overflow-hidden"
          onClick={(e) => e.stopPropagation()}>
            <button
            onClick={() => setPreviewImage(null)}
            className="absolute top-4 right-4 z-10 p-2 bg-white/90 hover:bg-white rounded-full shadow-lg transition-all duration-300">
              <X className="w-6 h-6 text-gray-700" />
            </button>
            <div className="p-4">
              <img
              src={previewImage}
              alt="Previsualización"
              className="w-full h-auto max-h-[80vh] object-contain rounded-lg" />

            </div>
            <div className="p-4 bg-gray-50 border-t border-gray-200 flex justify-center">
              <button
              onClick={() => handleDownload(previewImage, 'imagen.jpg')}
              className="flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-blue-600 to-green-600 hover:from-blue-700 hover:to-green-700 text-white rounded-xl transition-all duration-300 shadow-md">
                <Download className="w-5 h-5" />
                Descargar Imagen
              </button>
            </div>
          </motion.div>
        </div>
      }
    </div>);

};

export default ArchivosDescargables;